import Vue from 'vue'
import Router from 'vue-router'
// import PageHome from '@/components/PageHome'
// import PageSearch from '@/components/PageSearch'
// import HomeMain from '@/components/HomeMain'
// import SubWnd from '@/components/SubWnd'
// import PageCharge from '@/components/PageCharge'
// import WndPrivilege from '@/components/WndPrivilege'
// import Error from '@/components/Error'
// import PageBrowser from '@/components/PageBrowser'
// import PageGame from '@/components/PageGame'
// import GameServerList from '@/components/GameServerList'
// import GamePlay from '@/components/GamePlay'
// import GameOfficial from '@/components/GameOfficial'
// import PageClose from '@/components/PageClose'

// import Home from '@/views/Home'
// import Game from '@/views/Game'
// import Browser from '@/views/Browser'
// import Play from '@/views/Play'
// import Pay from '@/views/Pay'
// import Floor from '@/views/Floor'
// import BindPhone from '@/views/BindPhone'

Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
export default new Router({
  routes: [
    {
      path: '/wnd',
      name: 'SubWnd',
      component: resolve => require(['./components/SubWnd.vue'], resolve), // SubWnd,
      children: [
        {
          path: 'privilege',
          name: 'WndPrivilege',
          component: resolve =>
            require(['./components/WndPrivilege.vue'], resolve) // WndPrivilege
        }
      ]
    },
    // {
    //   path: '/close',
    //   name: 'PageClose',
    //   component: resolve => require(['./components/PageClose.vue'], resolve) // PageClose
    // },
    {
      path: '/',
      name: 'HomeMain',
      component: resolve => require(['./views/Home.vue'], resolve), // Home,
      // component: resolve => require(['@/views/Home'], resolve),
      redirect: 'home',
      children: [
        {
          path: 'home',
          name: 'HomeMain',
          component: resolve => require(['./components/HomeMain.vue'], resolve) // HomeMain
        },
        // {
        //   path: 'search',
        //   name: 'PageSearch',
        //   component: resolve =>
        //     require(['./components/PageSearch.vue'], resolve), // PageSearch,
        //   children: [
        //     {
        //       path: ':key',
        //       name: 'PageSearch',
        //       component: resolve =>
        //         require(['./components/PageSearch.vue'], resolve) // PageSearch
        //     }
        //   ]
        // },
        // {
        //   path: 'charge',
        //   name: 'PageCharge',
        //   component: resolve =>
        //     require(['./components/PageCharge.vue'], resolve) // PageCharge
        // },
        // {
        //   path: 'gifts',
        //   name: 'PageWelfare',
        //   component: resolve =>
        //     require(['./components/PageWelfare.vue'], resolve),
        //   redirect: 'gifts',
        //   children: [
        //     {
        //       path: '/gifts',
        //       name: 'gifts',
        //       component: resolve => require(['./components/gifts.vue'], resolve) // PageWelfare
        //     },
        //     {
        //       path: '/coupon',
        //       name: 'coupon',
        //       component: resolve =>
        //         require(['./components/coupon.vue'], resolve)
        //     },
        //     {
        //       path: '/jfq',
        //       name: 'jfq',
        //       component: resolve => require(['./components/jfq.vue'], resolve)
        //     },
        //     {
        //       path: '/mall',
        //       name: 'mall',
        //       component: resolve => require(['./components/mall.vue'], resolve)
        //     }
        //   ]
        // }
      ]
    },
    // {
    //   path: '/browser',
    //   name: 'browser',
    //   component: resolve => require(['./views/Browser.vue'], resolve), // Browser,
    //   redirect: '/browser',
    //   children: [
    //     {
    //       path: '',
    //       name: 'PageBrowser',
    //       component: resolve =>
    //         require(['./components/PageBrowser.vue'], resolve) // PageBrowser
    //     }
    //   ]
    // },
    // {
    //   path: '/game/:id',
    //   name: 'game',
    //   component: resolve => require(['./views/Game.vue'], resolve) // Game
    // },
    // {
    //   path: '/gamePlay',
    //   name: 'GamePlay',
    //   component: resolve => require(['./views/Play.vue'], resolve) // Play
    // },
    // {
    //   path: '/H5Game',
    //   name: 'H5Game',
    //   component: resolve => require(['./views/H5Game.vue'], resolve) // h5game
    // },
    // {
    //   path: '/Pay',
    //   name: 'Pay',
    //   component: resolve => require(['./views/Pay.vue'], resolve) // Pay
    // },
    {
      path: '/floor/:id',
      name: 'gameFloor',
      component: resolve => require(['./views/Floor.vue'], resolve) // Floor
    },
    // {
    //   path: '/bindPhone',
    //   name: 'bindPhone',
    //   component: resolve => require(['./views/FocusNum.vue'], resolve) // FocusNum
    // },
    // {
    //   path: '/Advertisement',
    //   name: 'Advertisement',
    //   component: resolve => require(['./views/Advertisement.vue'], resolve) // Advertisement
    // },
    // {
    //   path: '/ClockRemind',
    //   name: 'ClockRemind',
    //   component: resolve => require(['./views/ClockRemind.vue'], resolve) // ClockRemind
    // },
    // {
    //   path: '/ShutdownRemind',
    //   name: 'ShutdownRemind',
    //   component: resolve => require(['./views/ShutdownRemind.vue'], resolve) // ShutdownRemind
    // },
    // {
    //   path: '/Identify',
    //   name: 'Identify',
    //   component: resolve => require(['./views/Identify.vue'], resolve) // Identify
    // },
    // {
    //   path: '/IdentifyFull',
    //   name: 'IdentifyFull',
    //   component: resolve => require(['./views/IdentifyFull.vue'], resolve) // Identify
    // },
    // {
    //   path: '/CloseRemind',
    //   name: 'CloseRemind',
    //   component: resolve => require(['./views/CloseRemind.vue'], resolve) // CloseRemind
    // },
    // {
    //   path: '/GameGifts',
    //   name: 'GameGifts',
    //   component: resolve => require(['./views/GameGifts.vue'], resolve) // GameGifts
    // },
    // {
    //   path: '/Vistor',
    //   name: 'Vistor',
    //   component: resolve => require(['./views/Vistor.vue'], resolve) // VistorBind
    // }
  ]
})
